import React, { useEffect, useState } from "react";
import config from "react-global-configuration";
import CryptoJS from "crypto-js";
import Header from "./../../Header";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import GoogleBrandingIframe from './GoogleBrandingIframe';

const GroundingReportPage = (props) => {
    const interaction_id = props && props.match && props.match.params && props.match.params.id
        ? props.match.params.id
        : null;

    const [interactionData, setInteractionData] = useState(null);
    const [interactionLoading, setInteractionLoading] = useState(false);
    const [interactionError, setInteractionError] = useState(null);
    const [groundingMetadata, setGroundingMetadata] = useState(null);
    const [botContent, setBotContent] = useState(null);

    useEffect(() => {
        document.title = "Alie | AI Google Sources";
        if (interaction_id) {
            fetchInteraction();
        }
    }, [interaction_id]);

    const fetchInteraction = async () => {
        try {
            setInteractionLoading(true);
            setInteractionError(null);

            const response = await fetch(
                `${process.env.REACT_APP_CRM}/ai/interactions/${interaction_id}`
            );

            if (!response.ok) {
                throw new Error("Interaction API failed");
            }

            const result = await response.json();
            const interactionsList = result.data || [];

            const googleSearchObj = interactionsList.find(
                (item) => item.action === "google_search"
            );

            if (googleSearchObj && googleSearchObj.result && googleSearchObj.result.candidates) {
                const candidate = googleSearchObj.result.candidates[0];
                setInteractionData(result.data);
                
                if (candidate.groundingMetadata) {
                    setGroundingMetadata(candidate.groundingMetadata);
                }
                if (candidate.content) {
                    setBotContent(candidate.content);
                }
            } else {
                setInteractionError("No Google Search grounding data found for this interaction.");
            }
        } catch (err) {
            setInteractionError("Failed to load interaction details");
        } finally {
            setInteractionLoading(false);
        }
    };

    // --- Processing Logic (Only if data exists) ---
    let renderedContent = null;
    let rows = [];
    let annotatedText = "";

    if (groundingMetadata && groundingMetadata.groundingChunks && groundingMetadata.groundingSupports) {
        const { groundingChunks, groundingSupports } = groundingMetadata;

        // 1. Rendered Content
        if (groundingMetadata.searchEntryPoint && groundingMetadata.searchEntryPoint.renderedContent) {
            renderedContent = groundingMetadata.searchEntryPoint.renderedContent;
        }

        // 2. Table Rows
        groundingSupports.forEach((support, sIdx) => {
            if (support.groundingChunkIndices) {
                support.groundingChunkIndices.forEach((chunkIdx, cIdx) => {
                    const chunk = groundingChunks[chunkIdx];
                    if (chunk && chunk.web) {
                        rows.push({
                            uri: chunk.web.uri || "#",
                            title: chunk.web.title || "Source",
                            confidence: (support.confidenceScores && support.confidenceScores[cIdx]) || 0,
                            segmentText: (support.segment && support.segment.text) || "N/A",
                            key: sIdx + "-" + chunkIdx
                        });
                    }
                });
            }
        });

        // 3. Annotated Text
        let botText = "";
        if (botContent && botContent.parts && botContent.parts[0] && botContent.parts[0].text) {
            botText = botContent.parts[0].text;
        }

        const sortedSupports = [...groundingSupports].sort((a, b) => {
            const aStart = (a.segment && a.segment.startIndex) || 0;
            const bStart = (b.segment && b.segment.startIndex) || 0;
            return bStart - aStart;
        });

        annotatedText = botText;
        sortedSupports.forEach((support) => {
            const segment = support.segment;
            if (!segment || typeof segment.startIndex !== "number") return;
            const chunkIdx = support.groundingChunkIndices && support.groundingChunkIndices[0];
            const chunk = groundingChunks[chunkIdx];

            if (chunk && chunk.web && chunk.web.uri) {
                const url = chunk.web.uri;
                const displayTitle = chunk.web.title || "Source";
                const citation = " [[" + displayTitle + "]](" + url + ")";
                annotatedText = annotatedText.slice(0, segment.endIndex) + citation + annotatedText.slice(segment.endIndex);
            }
        });
    }


    // 1. Add this ref at the top with your other hooks


    return (
        <div>
            <Header brecum_name="AI" brecum_page="Google Sources" />

            <div className="right_col">
                <style>
  {`
    /* Targeting the scrollable columns */
    .col-md-6, .table-responsive {
      scrollbar-width: auto; /* For Firefox */
      scrollbar-color: #bbbbbb #f1f1f1; /* For Firefox */
    }

    /* Webkit (Chrome, Safari, Edge) */
    .col-md-6::-webkit-scrollbar,
    .table-responsive::-webkit-scrollbar {
      width: 12px; /* This increases the width */
      height: 12px;
    }

    .col-md-6::-webkit-scrollbar-track, 
    .table-responsive::-webkit-scrollbar-track {
      background: #f1f1f1; 
      border-radius: 10px;
    }

    .col-md-6::-webkit-scrollbar-thumb,
    .table-responsive::-webkit-scrollbar-thumb {
      background: #888; 
      border-radius: 10px;
      border: 3px solid #f1f1f1; /* Creates padding around the thumb */
    }

    .col-md-6::-webkit-scrollbar-thumb:hover, 
    .table-responsive::-webkit-scrollbar-thumb:hover {
      background: #555; 
    }
  `}
</style>
                <div className="ticket_list">

                    {interactionLoading && <div className="loader-new"></div>}


                    {!interactionLoading && interactionError && (
                        <div className="container text-center" style={{ marginTop: 50 }}>
                            <span className="text-danger">{interactionError}</span>
                        </div>
                    )}

                    {/* Content */}
                    {!interactionLoading && !interactionError && groundingMetadata && (
                        <div className="intranet_body">
                            <div className="title mob er_ids">
                                <div className="er_id">
                                    <span className="er">Google Sources Report</span>
                                </div>
                            </div>

                            <div class="request_details er row margin_top_less">
                                <div className="row">
                                    <div className="col-md-12 border-end bg-light p-4">
                                        {/* {renderedContent && (
                                            <div dangerouslySetInnerHTML={{ __html: renderedContent }} />
                                        )} */}

                                        <div className="p-2 bg-white border-bottom">
                                            {renderedContent && (
                                                <GoogleBrandingIframe html={renderedContent} />
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="row g-0" style={{ minHeight: "70vh" }}>

                                    {/* LEFT: Bot Response */}
                                    <div className="col-md-6 border-end bg-light p-4">
                                        <h6 className="text-muted small fw-bold mb-3">ANNOTATED RESPONSE</h6>
                                        <div className="bg-white p-4 border rounded shadow-sm" style={{ maxHeight: '60vh', overflowY: 'auto', lineHeight: '1.6', padding:'2em' }}>
                                            <ReactMarkdown 
                                                remarkPlugins={[remarkGfm]}
                                                components={{
                                                    a: ({node, ...props}) => (
                                                        <a {...props} target="_blank" rel="noopener noreferrer" 
                                                        style={{ textDecoration: 'none', fontSize: '11px', background: '#f1f3f4', color: '#1a73e8', padding: '2px 8px', borderRadius: '12px', marginLeft: '4px', border: '1px solid #dadce0', display: 'inline-flex', alignItems: 'center' }}>
                                                            <span style={{marginRight: '4px'}}>🔗</span>{props.children}
                                                        </a>
                                                    )
                                                }}
                                            >
                                                {annotatedText}
                                            </ReactMarkdown>
                                        </div>
                                    </div>

                                    {/* RIGHT: Source Table */}
                                    <div className="col-md-6 p-4">
                                        <h6 className="text-muted small fw-bold mb-3">SOURCE VERIFICATION</h6>
                                        <div className="table-responsive" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                                            <table className="table table-hover border align-middle" style={{ fontSize: "13px" }}>
                                                <thead className="table-light sticky-top">
                                                    <tr>
                                                        <th style={{ width: "25%" }}>Source</th>
                                                        <th>Verified Text from Source</th>
                                                        <th style={{ width: "15%" }} className="text-center">Confidence Index</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {rows.map((row) => (
                                                        <tr key={row.key}>
                                                            <td>
                                                                <a href={row.uri} target="_blank" rel="noopener noreferrer" className="fw-bold text-decoration-none text-primary">
                                                                    {row.title}
                                                                </a>
                                                            </td>
                                                            <td className="text-muted">{row.segmentText}</td>
                                                            <td className="text-center">
                                                                <span className="badge" style={{
                                                                    backgroundColor: row.confidence > 0.6 ? "#e8f5e9" : "#fff3e0",
                                                                    color: row.confidence > 0.6 ? "#2e7d32" : "#ef6c00",
                                                                    border: "1px solid " + (row.confidence > 0.6 ? "#c8e6c9" : "#ffe0b2")
                                                                }}>
                                                                    {(row.confidence * 100).toFixed(0)}%
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default GroundingReportPage;


// WEBPACK FOOTER //
// ./src/components/ai/GroundingReportPage.js